
import en from './en.json';
import fr from './fr.json';


export default {
  en: { translation: en },
  fr: { translation: fr },
};
